module.exports = __webpack_public_path__ + "assets/img/banner-footer-540.jpg";